import { render, staticRenderFns } from "./MainTemplate.vue?vue&type=template&id=41b60b7a&"
import script from "./MainTemplate.vue?vue&type=script&lang=ts&"
export * from "./MainTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./MainTemplate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports